import Vue from 'vue'
import Router from 'vue-router'
// import Login from '@/components/offcn-teacher-login/login'
import Download from '@/components/offcn-teacher-download/download'
import Downloads from '@/components/offcn-teacher-downloads/downloads'
import Disabled from '@/components/offcn-teacher-disabled/disabled'
import Uncompelete from '@/components/offcn-teacher-uncompelete/uncompelete'
import Error from '@/components/404'
// 小班课客户端唤起页面相关
import LoginRtc from '@/components/offcn-teacher-login-rtc/login'
import Launch from '@/components/offcn-teacher-launch/launch'
import Create from '@/components/offcn-teacher-create/create'
import List from '@/components/offcn-teacher-lottery/list'
import Establish from '@/components/offcn-teacher-lottery/create'
import Winlist from '@/components/offcn-teacher-lottery/winlist'
import Goodslist from '@/components/offcn-live-goods/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginRtc
    },
    {
      path: '/download',
      name: 'download',
      component: Download
    },
    {
      path: '/downloads',
      name: 'downloads',
      component: Downloads
    },
    {
      path: '/disabled',
      name: 'disabled',
      component: Disabled
    },
    {
      path: '/uncompelete',
      name: 'uncompelete',
      component: Uncompelete
    },
    {
      path: '*',
      name: 'error',
      component: Error
    },
    // 小班课客户端唤起页面相关
    {
      path: '/loginrtc',
      name: 'loginrtc',
      component: LoginRtc
    },
    {
      path: '/launch',
      name: 'launch',
      component: Launch
    },
    {
      path: '/create',
      name: 'create',
      component: Create
    },
    {
      path: '/drawlist',
      component: List
    },
    {
      path: '/teacher',
      component: List
    },
    {
      path: '/establish',
      component: Establish
    },
    // {
    //   path: '/content',
    //   component: Content
    // },
    {
      path: '/winlist',
      component: Winlist
    },
    {
      path: '/goodslist',
      component: Goodslist
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js